import { Meal } from "@/clients/models/Meal";
import { memo } from "react";
import { Navigation, Pagination, Virtual } from "swiper/modules";
import { Swiper, SwiperClass, SwiperSlide } from "swiper/react";
import { SwiperContent } from "./swiper-content";

interface MealSwiperProps {
  swapperRef: React.MutableRefObject<SwiperClass | null>;
  meals: Meal[];
  onSwiperSlideChange: (swiper: SwiperClass) => void;
  onSwiperTransitionEnd: (swiper: SwiperClass) => void;
}

export const MealSwiper = memo(
  ({
    swapperRef,
    meals,
    onSwiperSlideChange,
    onSwiperTransitionEnd,
  }: MealSwiperProps) => {
    return (
      <Swiper
        onSwiper={(swiper) => {
          swapperRef.current = swiper;
        }}
        slidesPerView={3}
        slidesPerGroup={1}
        freeMode={false}
        speed={400}
        centeredSlides={true}
        //   navigation={true}
        //   allowTouchMove={false}
        modules={[Pagination, Navigation, Virtual]}
        className="mySwiper w-full h-full p-8"
        onSlideChange={onSwiperSlideChange}
        onTransitionEnd={onSwiperTransitionEnd}
        virtual
      >
        {meals.map((meal, index) => {
          return (
            <SwiperSlide
              key={meal.id || index}
              virtualIndex={index}
              className="relative"
            >
              {({ isActive, isNext, isPrev }) => {
                return (
                  <SwiperContent
                    id={meal.id}
                    name={meal.name}
                    imageUri={meal.imageUri}
                    isActive={isActive}
                    isNext={isNext}
                    isPrev={isPrev}
                  />
                );
              }}
            </SwiperSlide>
          );
        })}
      </Swiper>
    );
  },
);
